import {Controller, useFieldArray, useFormContext} from "react-hook-form";
import {usePricingCurrencies} from "@/features/currencies";
import {useVariantCurrencyOptions} from "../../../pricing/hooks/currency";
import {Button, Col, Row, Select, Space, Tooltip} from "antd";
import {CustomInputComponent} from "../../../../../input/input-component";
import {FormFieldError} from "../../../../../../design-system/form-field";
import {DeleteOutlined, PlusCircleFilled} from "@ant-design/icons";
import {ProductVariantsFormFieldsProps, ProductVariantsFormValues} from "../../types";
import {useCreateProductContext} from "../../../../../../products/useCases/create-product/context/create-product";
import {useEffect, useMemo, useRef} from "react";
import {ProductPricingFormFieldsType} from "../../../pricing/types";
import {useVariantCurrenciesEnforcer} from "../../hooks/use-variant-curriencies-enforcer";

function isEqualArray<T extends Record<string, any>>(a: T[], b: T[]) {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const keys = Object.keys(a[i]);
    for (const key of keys) {
      if (a[i][key] !== b[i][key]) return false;
    }
  }
  return true;
}

const toKey = (arr: {currency: string; price: number}[] | undefined) =>
  (arr ?? []).map((x) => `${x.currency}:${x.price}`).join("|");

type VariantOptionListItemOptionCurrencyListFormFieldProps = {
  variantIndex: number;
  optionIndex: number;
  label: string;
  placeholder?: string;
  productCurrencies: ProductPricingFormFieldsType["currencies"];
  productSelectedPriceType: "paid" | "free";
  hydratedRef: ProductVariantsFormFieldsProps["hydratedRef"];
};

export function VariantOptionListItemOptionCurrencyListFormField({
  optionIndex,
  variantIndex,
  label,
  placeholder,
  productCurrencies,
  productSelectedPriceType,
  hydratedRef,
}: VariantOptionListItemOptionCurrencyListFormFieldProps) {
  const pricingCurrencies = usePricingCurrencies();
  const {
    control,
    watch,
    formState: {errors},
    getValues,
  } = useFormContext<ProductVariantsFormValues>();
  const variantOptionCurrenciesKey =
    `variants.${variantIndex}.options.${optionIndex}.currencies` as const;
  const {
    fields: currencyFields,
    append: appendCurrency,
    remove,
    replace,
  } = useFieldArray({
    control,
    name: variantOptionCurrenciesKey,
  });

  const currencyArrayValue = watch(variantOptionCurrenciesKey);
  const defaultCallCurrency =
    watch(variantOptionCurrenciesKey).length > 0
      ? watch(variantOptionCurrenciesKey)[0].currency
      : null;
  console.log({currencyArrayValue});

  // Build the desired target list from productCurrencies + current value
  // const targetCurrencies = useMemo(() => {
  //   // when product has currencies and price type is paid, filter by product
  //   if (productCurrencies.length > 0 && productSelectedPriceType === "paid") {
  //     const basicSet = new Set(productCurrencies.map((b) => b.callPriceCurrency));
  //     const filtered = (currencyArrayValue ?? []).filter((v) => basicSet.has(v.currency));

  //     return filtered.length > 0
  //       ? filtered
  //       : [{currency: productCurrencies[0].callPriceCurrency, price: 100}];
  //   }

  //   // otherwise default NGN
  //   return [{currency: "NGN", price: 100}];
  // }, [currencyArrayValue, productCurrencies, productSelectedPriceType]);

  // const toKey = (arr: {currency: string; price: number}[] = []) =>
  //   arr.map((x) => `${x.currency}:${x.price}`).join("|");

  // const currentKey = toKey(currencyArrayValue);
  // const targetKey = toKey(targetCurrencies);

  // useEffect(() => {
  //   if (currentKey !== targetKey) replace(targetCurrencies);
  // }, [currentKey, replace, targetCurrencies, targetKey]);

  // function filterByBasicCurrencies(
  //   variantCurrencyArray: ProductVariantsFormValues["variants"][number]["options"][number]["currencies"],
  //   basicFormCurrencyArray: ProductPricingFormFieldsType["currencies"]
  // ): ProductVariantsFormValues["variants"][number]["options"][number]["currencies"] {
  //   const basicSet = new Set(basicFormCurrencyArray.map((b) => b.callPriceCurrency));
  //   return variantCurrencyArray.filter((v) => basicSet.has(v.currency));
  // }

  // useEffect(() => {
  //   if (productCurrencies.length > 0 && productSelectedPriceType === "paid") {
  //     const filteredVariantProductCurrencies = filterByBasicCurrencies(
  //       currencyArrayValue,
  //       productCurrencies
  //     );
  //     const defaultCurrencies =
  //       filteredVariantProductCurrencies.length > 0
  //         ? filteredVariantProductCurrencies
  //         : [
  //             {
  //               currency: productCurrencies[0].callPriceCurrency,
  //               price: 100,
  //             },
  //           ];

  //     replace(defaultCurrencies);
  //   } else {
  //     replace([
  //       {
  //         currency: "NGN",
  //         price: 100,
  //       },
  //     ]);
  //   }
  // }, [productSelectedPriceType, replace]);

  // const lastAppliedKeyRef = useRef<string | null>(null);

  // useEffect(() => {
  //   // FREE → force NGN once
  //   if (productSelectedPriceType !== "paid") {
  //     const next = [{currency: "NGN", price: 100}];
  //     const nextKey = toKey(next);
  //     const currentKey = toKey(currencyArrayValue);
  //     if (currentKey !== nextKey && lastAppliedKeyRef.current !== nextKey) {
  //       lastAppliedKeyRef.current = nextKey;
  //       replace(next);
  //     }
  //     return;
  //   }

  //   // PAID with product currencies → subset
  //   if (productCurrencies.length > 0) {
  //     const allowed = new Set(productCurrencies.map((c) => c.callPriceCurrency));
  //     const filtered = (currencyArrayValue ?? []).filter((v) => allowed.has(v.currency));
  //     const next =
  //       filtered.length > 0
  //         ? filtered
  //         : [{currency: productCurrencies[0].callPriceCurrency, price: 100}];

  //     const nextKey = toKey(next);
  //     const currentKey = toKey(currencyArrayValue);
  //     if (currentKey !== nextKey && lastAppliedKeyRef.current !== nextKey) {
  //       lastAppliedKeyRef.current = nextKey;
  //       replace(next);
  //     }
  //   }
  //   // IMPORTANT: no currencyArrayValue in deps
  // }, [productCurrencies, productSelectedPriceType, replace]);

  // // Build a stable key from an array of {currency, price}
  // const toKey = (arr?: {currency: string; price: number}[]) =>
  //   (arr ?? []).map((x) => `${x.currency}:${x.price}`).join("|");

  // // Build a stable key from product currencies
  // const productKey = useMemo(
  //   () =>
  //     productCurrencies
  //       .map((c) => c.callPriceCurrency)
  //       .sort()
  //       .join("|"),
  //   [productCurrencies]
  // );

  // const lastAppliedKeyRef = useRef<string | null>(null);
  // const initializedRef = useRef(false);

  // useEffect(() => {
  //   // construct the desired value based on product settings
  //   const ensureSubset = () => {
  //     if (productSelectedPriceType !== "paid") {
  //       return [{currency: "NGN", price: 100}];
  //     }
  //     if (productCurrencies.length === 0) {
  //       return [{currency: "NGN", price: 100}];
  //     }

  //     const allowed = new Set(productCurrencies.map((c) => c.callPriceCurrency));
  //     const filtered = (currencyArrayValue ?? []).filter((v) => allowed.has(v.currency));

  //     return filtered.length > 0
  //       ? filtered
  //       : [{currency: productCurrencies[0].callPriceCurrency, price: 100}];
  //   };

  //   const next = ensureSubset();
  //   const currentKey = toKey(currencyArrayValue);
  //   const nextKey = toKey(next);

  //   // avoid redundant replace
  //   if (nextKey === currentKey || nextKey === lastAppliedKeyRef.current) {
  //     initializedRef.current = true;
  //     return;
  //   }

  //   // Only enforce on first mount of this step OR when product inputs change
  //   // (productKey / productSelectedPriceType). This avoids clobbering user edits.
  //   if (!initializedRef.current || productSelectedPriceType === "paid") {
  //     lastAppliedKeyRef.current = nextKey;
  //     initializedRef.current = true;
  //     replace(next);
  //   }
  //   // deps intentionally exclude currencyArrayValue
  // }, [productKey, productSelectedPriceType, replace]);

  // const toKey = (arr?: {currency: string; price: number}[]) =>
  //   (arr ?? []).map((x) => `${x.currency}:${x.price}`).join("|");

  // const lastAppliedKeyRef = useRef<string | null>(null);

  // const productKey = useMemo(
  //   () =>
  //     productCurrencies
  //       .map((c) => c.callPriceCurrency)
  //       .sort()
  //       .join("|"),
  //   [productCurrencies]
  // );

  // useEffect(() => {
  //   if (hydratedRef && !hydratedRef.current) return; // ⛔ don't enforce before RHF has user data

  //   const next = (() => {
  //     if (productSelectedPriceType !== "paid" || productCurrencies.length === 0) {
  //       const arr = getValues(
  //         `variants.${variantIndex}.options.${optionIndex}.currencies`
  //       );
  //       if (!arr || arr.length === 0) {
  //         replace([{currency: "NGN", price: 0}]); // one-time init
  //       }
  //       return [{currency: "NGN", price: 100}];
  //     }
  //     const allowed = new Set(productCurrencies.map((c) => c.callPriceCurrency));
  //     const filtered = (currencyArrayValue ?? []).filter((v) => allowed.has(v.currency));
  //     return filtered.length > 0
  //       ? filtered
  //       : [{currency: productCurrencies[0].callPriceCurrency, price: 100}];
  //   })();

  //   const currentKey = toKey(currencyArrayValue);
  //   const nextKey = toKey(next);

  //   if (nextKey !== currentKey && nextKey !== lastAppliedKeyRef.current) {
  //     lastAppliedKeyRef.current = nextKey;
  //     replace(next);
  //   }
  //   // deps: only product constraints; NOT currencyArrayValue
  // }, [productKey, productSelectedPriceType, replace]);

  useVariantCurrenciesEnforcer({
    variantIndex,
    optionIndex,
    productSelectedPriceType,
    productCurrencies,
    replace,
  });

  const {
    addNewCurrency,
    canAddCurrency,
    currencyOptions,
    nextSuggestedCurrency,
    onCurrencyChange,
    removeCurrency,
  } = useVariantCurrencyOptions(
    currencyArrayValue,
    defaultCallCurrency,
    appendCurrency,
    remove,
    productCurrencies
  );

  // console.log({
  //   productCurrencies,
  //   currencyArrayValue,
  //   canAddCurrency,
  //   nextSuggestedCurrency,
  //   currencyOptions,
  // });

  const paidPriceTypeSelectedAndBankConnected =
    watch(`variants.${variantIndex}.options.${optionIndex}.priceType`) === "paid" &&
    pricingCurrencies.connectedBankStatus.isBankConnected;
  return (
    <div>
      {paidPriceTypeSelectedAndBankConnected && (
        <Space direction="vertical" size={24} style={{display: "flex"}}>
          <Row gutter={[10, 24]}>
            {currencyFields.map((item, index) => (
              <Col key={item.id} span={24} sm={12}>
                <div style={{display: "flex", gap: "1.6rem"}}>
                  <div style={{flex: "1"}}>
                    <CustomInputComponent
                      id={`variant-${variantIndex}-option-${optionIndex}`}
                      name={`variants.${variantIndex}.options.${optionIndex}.currencies.${index}.price`}
                      type="text"
                      label={label}
                      placeholder={placeholder ?? ""}
                      error={
                        errors.variants?.[variantIndex]?.options?.[optionIndex]
                          ?.currencies?.[index]?.currency
                          ? errors.variants?.[variantIndex]?.options?.[optionIndex]
                              ?.currencies?.[index]?.currency?.message
                          : errors.variants?.[variantIndex]?.options?.[optionIndex]
                              ?.currencies?.[index]?.price?.message
                      }
                      control={control}
                      addonBefore={
                        <Controller
                          control={control}
                          name={`variants.${variantIndex}.options.${optionIndex}.currencies.${index}.currency`}
                          render={({field: {onChange, value, ref}}) => (
                            <Space
                              size={16}
                              direction="vertical"
                              style={{display: "flex"}}
                            >
                              <Select
                                onChange={(val) => onCurrencyChange(val, onChange)}
                                value={value}
                                ref={ref}
                                size="large"
                                status={
                                  errors.variants?.[variantIndex]?.options?.[optionIndex]
                                    ?.currencies?.[index]?.currency?.message
                                    ? "error"
                                    : ""
                                }
                                showSearch={false}
                                notFoundContent={null}
                                placeholder={""}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option!.children as unknown as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {currencyOptions.map(
                                  (option, optionIdx: number | string) => (
                                    <Select.Option
                                      key={optionIdx}
                                      value={option.toUpperCase()}
                                    >
                                      {option.toUpperCase()}
                                    </Select.Option>
                                  )
                                )}
                              </Select>
                              <FormFieldError
                                errorMessage={
                                  errors.variants?.[variantIndex]?.options?.[optionIndex]
                                    ?.currencies?.[index]?.currency?.message
                                }
                              />
                            </Space>
                          )}
                        />
                      }
                    />
                  </div>
                  <div style={{marginTop: "auto"}}>
                    <Tooltip
                      title={
                        currencyFields.length === 1
                          ? "At least one currency is required"
                          : null
                      }
                    >
                      <Button
                        onClick={() => removeCurrency(index)}
                        type="link"
                        shape="circle"
                        icon={<DeleteOutlined />}
                        size="small"
                        disabled={currencyFields.length === 1}
                      />
                    </Tooltip>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          {watch(`variants.${variantIndex}.options.${optionIndex}.priceType`) ===
            "paid" && (
            <div>
              <Button
                disabled={!canAddCurrency}
                icon={<PlusCircleFilled />}
                onClick={() => addNewCurrency()}
                size="small"
              >
                Add currency
              </Button>
            </div>
          )}
        </Space>
      )}
    </div>
  );
}
